import React from 'react';
import { IClientContactData } from '../../../../types/contacts/IClientContact';
import { Form, Formik } from 'formik';
import { Grid, SideSheet } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { NewContactTypeButtonPair } from './NewContactButtonPair';
import { FormStatusWrapper } from '../../../shared/FormStatusWrapper/FormStatusWrapper';
import { SideSheetFormFooter } from '../../../shared/SideSheetFormFooter';
import { ObjectSchema } from 'yup';

export interface INewContactFormikProps {
  addFetchError?: Error;
  addFetchStatus: IFetchStatus;
  addPreExistingContact: boolean;
  setAddPreExistingContact: (bool: boolean) => void;
  onCancel: () => void;
  onSubmit: (value: any) => void;
  validationSchema: () => ObjectSchema<{}>;
  title: string;
  duplicateMessage?: string;
  children?: React.ReactNode;
}

export const NewContactFormik: React.FC<INewContactFormikProps> = ({
  addFetchError,
  addFetchStatus,
  addPreExistingContact,
  setAddPreExistingContact,
  onCancel,
  onSubmit,
  validationSchema,
  children,
  title,
  duplicateMessage,
}) => {
  const initialValues: Partial<IClientContactData> = {};
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnMount={true}
      validationSchema={validationSchema}
    >
      <Form>
        <SideSheet
          title={title}
          onClose={onCancel}
          footer={<SideSheetFormFooter onCancel={onCancel} saveButtonText={'Save and Add'} />}
        >
          <Grid>
            <NewContactTypeButtonPair
              preExistingContact={addPreExistingContact}
              setAddPreExistingContactForm={setAddPreExistingContact}
            />
            <FormStatusWrapper
              fetching={addFetchStatus.fetching}
              fetchedSuccess={addFetchStatus.success}
              fetchError={addFetchError}
              successMessage={'Contact Added!'}
              duplicateMessage={duplicateMessage}
              onOkClick={onCancel}
            />
            {children}
          </Grid>
        </SideSheet>
      </Form>
    </Formik>
  );
};
